// Simple sound effects using Web Audio API
let audioCtx = null;

function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

function playTone(frequency, duration, type = 'sine', volume = 0.3) {
  try {
    const ctx = getAudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.value = frequency;
    gain.gain.value = volume;
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch { /* silent */ }
}

export function playCoinSound() {
  // Bright, cheerful coin clink - two ascending notes
  playTone(880, 0.1, 'sine', 0.2);
  setTimeout(() => playTone(1320, 0.15, 'sine', 0.25), 80);
  setTimeout(() => playTone(1760, 0.2, 'sine', 0.15), 160);
}

export function playCelebrationSound() {
  // Triumphant fanfare - ascending arpeggio
  const notes = [523, 659, 784, 1047, 1319];
  notes.forEach((freq, i) => {
    setTimeout(() => playTone(freq, 0.2, 'sine', 0.2), i * 100);
  });
  // Add a sparkle
  setTimeout(() => playTone(2093, 0.3, 'sine', 0.1), 500);
}

export function playClickSound() {
  playTone(600, 0.05, 'sine', 0.1);
}

export function playSuccessSound() {
  playTone(523, 0.1, 'sine', 0.15);
  setTimeout(() => playTone(659, 0.1, 'sine', 0.15), 100);
  setTimeout(() => playTone(784, 0.15, 'sine', 0.15), 200);
}

export function playAddSound() {
  // Gentle "pop" sound
  playTone(440, 0.08, 'sine', 0.15);
  setTimeout(() => playTone(660, 0.1, 'sine', 0.1), 60);
}
